import { gsap } from 'gsap'
export class DateMore {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      if (document.querySelectorAll('.js-date_aco').length === 0) return
      const trgs = document.querySelectorAll('.js-date_aco_trg')
      const schedules = document.querySelector('.js-date_aco')
      const list = [...schedules.getElementsByTagName('tr')]
      trgs.forEach((trg) => {
        trg.addEventListener('click', (event) => {
          let $this = event.currentTarget

          $this.classList.toggle('is-act')
          $this.previousElementSibling.classList.toggle('is-act')
          if ($this.classList.contains('is-act')) {
            $this.querySelector('.text').innerText = '閉じる'
            $this.querySelector('.btn_icon').classList.remove('down')
            $this.querySelector('.btn_icon').classList.add('up')
            list.forEach((item, i) => {
              if (i > 3) {
                animation(item, 'visible')
              }
            })
          } else {
            $this.querySelector('.text').innerText = 'さらに日程を見る'
            $this.querySelector('.btn_icon').classList.remove('up')
            $this.querySelector('.btn_icon').classList.add('down')
            list.forEach((item, i) => {
              if (i > 3) {
                animation(item, 'hidden')
              }
            })
          }
        })
      })

      const animation = (el, type) => {
        if (type == 'visible') {
          // gsap.to(el, 0.3, { autoAlpha: 1, display: 'flex' })
          el.classList.add('is-act')
        } else {
          // gsap.to(el, 0.3, { autoAlpha: 0, display: 'none' })
          el.classList.remove('is-act')
        }
      }
    })
  }
}
